import React from "react";
import { TinyColor } from "@ctrl/tinycolor";
import { Button, Tooltip } from "antd";
import { PlusOutlined, ExclamationCircleFilled } from "@ant-design/icons";

import "./SpeakerElement.css";

const ErrorIndicator = () => {
  return (
    <Tooltip title="Texte trop long">
      <ExclamationCircleFilled style={{ color: "red", fontSize: 35 }} />
    </Tooltip>
  );
};

const NarrateurBubble = (props) => {
  const { element, children, attributes } = props;
  return (
    //
    <div className="container-bubble">
      {element.children.reduce((acc, c) => (acc += c.text.length), 0) > 400 ? (
        <ErrorIndicator />
      ) : (
        <Button
          contentEditable={false}
          style={{
            margin: "15px",
          }}
          type="primary"
          shape="circle"
          // className={"avatar"}
          onClick={props.onClick}
          icon={<PlusOutlined />}
        />
      )}

      <div className="bubble" {...attributes}>
        <p
          contentEditable={false}
          className="speaker"
          style={{
            display: "inline",
            background: new TinyColor("#E8E8E8").darken(30).toString(),
            color: new TinyColor("#E8E8E8").toString(),
            padding: 4,
            borderRadius: 5,
          }}
        >
          {element.speaker.name}
        </p>

        <p className={"txt"}>{children}</p>
      </div>
    </div>
  );
};

// `https://newbrand.s3.eu-west-3.amazonaws.com/personnages/${perso.img}`
const PersoBubble = (props) => {
  const { element, children, attributes } = props;
  const { speaker } = element;
  const bubbleColor = new TinyColor(speaker.color).toString("hex6");

  const speakerImg = speaker.img ? (
    <img
      className="avatar"
      src={`https://newbrand.s3.eu-west-3.amazonaws.com/personnages/${speaker.img}`}
      alt="Girl in a jacket"
    />
  ) : (
    <div
      className="dot-avatar"
      style={{
        backgroundColor: bubbleColor,
      }}
    />
  );

  return (
    <div className="container-bubble">
      <div
        contentEditable={false}
        className={"avatarContainer"}
        onClick={props.onClick}
      >
        {element.children.reduce((acc, c) => (acc += c.text.length), 0) >
        400 ? (
          <ErrorIndicator />
        ) : (
          speakerImg
        )}
      </div>
      <div
        className="bubble"
        style={{ backgroundColor: bubbleColor }}
        {...attributes}
      >
        <p
          contentEditable={false}
          className="speaker"
          style={{
            display: "inline",
            background: new TinyColor(speaker.color).lighten(50).toString(),
            color: new TinyColor(speaker.color).darken(50).toString(),
            padding: 4,
            borderRadius: 5,
          }}
        >
          {speaker.displayName || speaker.name}
        </p>
        <p className="txt" style={{ color: "white" }}>
          {children}
        </p>
      </div>
    </div>
  );
};

const SpeakerElement = (props) => {
  const { element } = props;
  const isNarrateur =
    element.speaker.name && element.speaker.name.toLowerCase() !== "narrateur";

  return (
    <>
      {isNarrateur ? (
        <PersoBubble {...props} onClick={props.onClick} />
      ) : (
        <NarrateurBubble {...props} onClick={props.onClick} />
      )}
    </>
  );
};

export default SpeakerElement;
